import { CoachUser } from '../../interface/Coach';

export type { CoachUser };

// Keys that are editable on the coach personal info page
export const coachEditableFieldKeys = [
    'bio',
    'yearsOfExperience',
    'specialties',
    'certifications',
    'languages',
] as const;

export type CoachEditableFieldKey = typeof coachEditableFieldKeys[number];

export const coachFieldLabels: Record<CoachEditableFieldKey, string> = {
    bio: 'Bio',
    yearsOfExperience: 'Years of Experience',
    specialties: 'Specialties',
    certifications: 'Certifications',
    languages: 'Languages',
};

// Normalize updated coach fields from profileData into a partial CoachUser object
export function buildCoachUpdateFromProfileData(profileData: Record<string, any>): Partial<CoachUser> {
    const years = profileData.yearsOfExperience;
    const toArray = (val: any): string[] => {
        if (!val) return [];
        if (Array.isArray(val)) return val.map(String);
        return String(val)
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);
    };

    const certifications = toArray(profileData.certifications);
    const specialties = toArray(profileData.specialties);
    const languages = toArray(profileData.languages);

    const update: Partial<CoachUser> = {};
    if (profileData.bio !== undefined) update.bio = String(profileData.bio || '');
    if (years !== undefined) {
        const num = Number(years);
        update.yearsOfExperience = Number.isFinite(num) ? num : 0;
    }
    if (specialties !== undefined) update.specialties = specialties;
    if (certifications !== undefined) update.certifications = certifications;
    if (languages !== undefined) update.languages = languages;
    return update;
}


